import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import SelectOption from "components/select/SelectOption";
import { Divider } from "antd";
import {
  Users,
  DollarSign,
  Clock,
  TrendingUp,
  GraduationCap,
  Award,
  CircleCheck,
} from "lucide-react";

const iconMap = {
  users: Users,
  "dollar-sign": DollarSign,
  clock: Clock,
  "trending-up": TrendingUp,
  "graduation-cap": GraduationCap,
  award: Award,
};

export default function SelectReportType({
  analyticsCards,
  selectedCard,
  onSelectCard,
}) {
  return (
    <div className="col-span-2">
      <HeaderComponent
        title="Select Report Type"
        description="Choose from pre-built templates"
        descriptionClass="text-sm muted-text"
        bgcolor="bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-900 dark:to-orange-900"
        rightNav={
          <SelectOption
            placeholder="All Categories"
            options={[
              { label: "All Categories", value: 0 },
              { label: "People", value: 1 },
              { label: "Financial", value: 2 },
              { label: "Operations", value: 3 },
              { label: "Development", value: 4 },
              { label: "Engagement", value: 5 },
            ]}
          />
        }
      >
        <div className="grid grid-cols-2 gap-4 max-h-[600px] overflow-y-auto pr-2 py-2">
          {analyticsCards.map((card, index) => {
            const Icon = iconMap[card.icon];
            const isSelected = selectedCard === card.title;

            return (
              <div
                key={index}
                onClick={() =>
                  onSelectCard(isSelected ? null : card.title)
                }
                className={`p-4 flex flex-col gap-2 rounded-xl report card-select cursor-pointer transition-all duration-300 hover:shadow-lg overflow-hidden border-2 
                  ${
                    isSelected
                      ? `bg-gradient-to-br ${card.title
                          .toLowerCase()
                          .replace(/\s+/g, "-")} border-red-400 dark:border-red-900`
                      : "border-slate-200 hover:border-red-300 dark-mode-card dark:border-slate-700 dark:hover:border-red-800"
                  }`}
              >
                <div className="flex items-start gap-3">
                  <div
                    className={`p-2.5 shadow-md !rounded-2xl icon-style ${card.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {Icon && <Icon className="w-5 h-5 text-white" />}
                  </div>

                  <div className="flex-1 space-y-1">
                    <h4 className="font-semibold text-[14px] title-text">
                      {card.title}
                    </h4>
                    <span className="status-indicator normal text-[9px] py-0 title-text">
                      {card.category}
                    </span>
                    <p className="text-[11px] muted-text">
                      {card.description}
                    </p>
                  </div>

                  {isSelected && (
                    <CircleCheck className="text-red-600 w-5 h-5 dark:text-red-500" />
                  )}
                </div>

                <Divider style={{ margin: "0", borderColor: "#e5e7eb" }} />

                <div className="flex flex-wrap gap-1">
                  {card.tags.slice(0, 3).map((tag, i) => (
                    <span
                      key={i}
                      className="status-indicator normal !border-none bg-gray-50 text-[9px] py-0"
                    >
                      {tag}
                    </span>
                  ))}

                  {card.tags.length > 3 && (
                    <span className="status-indicator normal !border-none bg-gray-50 text-[9px] py-0">
                      +{card.tags.length - 3}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </HeaderComponent>
    </div>
  );
}
